<template>
  <v-row no-gutters class="fill-height">
    <crud-factory :serviceName="serviceName" :crudDialog="crudDialog" />
  </v-row>
</template>

<script>
export default {
  components: {
    crudFactory: () => import("./CrudFactory"),
  },
  data() {
    return {
      serviceName: "ambits-generals",
      crudDialog: {
        large: false,
        createTitle: "Nou àmbit general",
        modelKeyTitle: "nom",
      },
    }
  },
}
</script>

<style lang="scss" scoped />
